import { render, staticRenderFns } from "./errorCorrection.vue?vue&type=template&id=32508f8b&scoped=true&"
import script from "./errorCorrection.vue?vue&type=script&lang=js&"
export * from "./errorCorrection.vue?vue&type=script&lang=js&"
import style0 from "./errorCorrection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./errorCorrection.vue?vue&type=style&index=1&id=32508f8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32508f8b",
  null
  
)

export default component.exports